// The venue suite: עמדת אירוח (the reception-desk login + screens) and the customer-page tabs fed
// by the couple's mit4mit wedplanner. Service ids mirror
// apiv2/src/modules/hosting-station/hosting-station-link.ts — KEEP IN SYNC.
export const HOSTING_STATION_SERVICE_ID = '11';
export const RSVP_TAB_SERVICE_ID = '12';
export const VENDORS_TAB_SERVICE_ID = '13';
export const SEATING_TAB_SERVICE_ID = '14';
export const ARRIVALS_TAB_SERVICE_ID = '15';
export const VENUE_SUITE_SERVICE_IDS = [HOSTING_STATION_SERVICE_ID, RSVP_TAB_SERVICE_ID, VENDORS_TAB_SERVICE_ID, SEATING_TAB_SERVICE_ID, ARRIVALS_TAB_SERVICE_ID];
// טופס הפקה — the production questionnaire tab + the couple's public link (its own gate, its own
// settings page; not part of the suite list above)
export const PRODUCTION_FORM_SERVICE_ID = '17';

// The reception-desk user: a child user whose permissions carry this marker (and nothing else).
// Mirrors HOSTING_STATION_MARKER on the backend (role-permissions.ts).
export const HOSTING_STATION_MARKER = 'hostingStation';

// users.bizServices is the account-level list the system admin toggles (strings or numbers)
export function hasService(user, id) {
   if (!user) return false;
   return (user.bizServices || []).map(String).indexOf(String(id)) > -1;
}

export function hasAnyService(user, ids) {
   return (ids || []).some(id => hasService(user, id));
}

export function isHostingStationUser(user) {
   if (!user || user.type !== 6) return false;
   var p = user.permissions;
   if (!p) return false;
   return Array.isArray(p) ? p.indexOf(HOSTING_STATION_MARKER) > -1 : Object.keys(p).indexOf(HOSTING_STATION_MARKER) > -1;
}

// where a login lands: the root admin on the accounts dashboard, the reception desk on its
// station, everyone else on the dashboard
export function homeRouteFor(user) {
   if (user && user.type === 1) return '/root-admin/tenants';
   if (isHostingStationUser(user)) return '/hosting-station';
   return '/dashboard';
}
